import { render, staticRenderFns } from "./rewardConfig.vue?vue&type=template&id=fef614a6&scoped=true&"
import script from "./rewardConfig.vue?vue&type=script&lang=js&"
export * from "./rewardConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef614a6",
  null
  
)

export default component.exports